import {Component, OnInit, Input} from '@angular/core';
import {MetricIconService} from 'src/app/services/metrics/metrics-icons.service';
import {PermissionsService} from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-employee-feedback',
  templateUrl: './employee-feedback.component.pug',
  styleUrls: ['./employee-feedback.component.scss'],
  standalone: false
})
export class EmployeeFeedbackComponent implements OnInit {
  @Input() data: any;
  moment: any;
  questionsLeft: any;
  questionsRight: any;
  answers = {
    "1": $localize`Strongly Disagree`,
    "2": $localize`Disagree`,
    "3": $localize`Neither agree nor disagree`,
    "4": $localize`Agree`,
    "5": $localize`Strongly Agree`,
  };

  constructor(
    public metricIconService: MetricIconService,
    private permissionsService: PermissionsService
  ) {
  }

  ngOnInit(): void {
    this.answers["1"] = $localize`Strongly disagree`
    this.answers["5"] = $localize`Strongly agree`
    this.initData();

    this.questionsLeft = this.data;
    this.questionsRight = [];
  }

  getMetricIcon(metric) {
    return this.metricIconService.getMetricIcon(metric);
  }

  hasAdditionalComments(question: any): boolean {
    if (!question || !question.additional_comments) {
      return false;
    }
    
    if (typeof question.additional_comments !== 'string') {
      return false;
    }
    
    return question.additional_comments.trim().length > 0;
  }

  initData() {
    let count = 0
    if (this.data) {
      this.data.forEach(question => {
        question.count = count += 1;
        question.answer_text = this.answers[question.answer];
        this.setAnswerColour(question);
      });
    }
  }

  setAnswerColour(question: any) {
    if (question.answer === '1' || question.answer === '2') {
      question.answerColour = 'red';
    } else if (question.answer === '3') {
      question.answerColour = 'yellow';
    } else if (question.answer === '4' || question.answer === '5') {
      question.answerColour = 'green';
    }
  }
}
